import React, { useContext } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { AppContext } from "../../../app/store";
import { getPDEInfo, useTranslate } from "../../../helpers";
import { PrescriptionDrug } from "../../../@types";
import { PDESelector, getSelectedPdes } from "../../../components/PDESelector";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../../../app/contexts/Analytics/types";

interface AddPDEsProps {
  onAddPDEs: (pdes: PrescriptionDrug[]) => void;
  onCancel: () => void;
}

export const AddPDEs = ({ onAddPDEs, onCancel }: AddPDEsProps) => {
  const {
    state: { prescriptions, beneficiary },
    dispatch,
  } = useContext(AppContext);
  const t = useTranslate();
  const { savedPdes, unsavedPdes } = getPDEInfo(
    prescriptions,
    beneficiary?.pdes
  );

  const onAddDrugs = (): void => {
    const selectedPdes = getSelectedPdes(unsavedPdes);
    onAddPDEs(selectedPdes);
  };

  return (
    <div className="mct-c-add-pdes">
      <p className="ds-u-margin-top--0">{t("summary_page.add_pde.info")}</p>
      <PDESelector savedPdes={savedPdes} unsavedPdes={unsavedPdes} />
      <div className="ds-u-margin-top--5">
        <Button
          variation="solid"
          onClick={() => {
            dispatch({
              type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
              settings: {
                button: {
                  buttonStyle: AnalyticsButtonStyle.PRIMARY,
                  buttonType: AnalyticsButtonType.BUTTON,
                  text: t("summary_page.add_pde.add_drugs"),
                },
              },
            });
            onAddDrugs();
          }}
        >
          {t("summary_page.add_pde.add_drugs")}
        </Button>
        <Button
          className="ds-u-margin-left--3"
          onClick={() => {
            dispatch({
              type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
              settings: {
                button: {
                  buttonStyle: AnalyticsButtonStyle.DEFAULT,
                  buttonType: AnalyticsButtonType.BUTTON,
                  text: t("cancel"),
                },
              },
            });
            onCancel();
          }}
        >
          {t("cancel")}
        </Button>
      </div>
    </div>
  );
};
